export default "__VITE_ASSET__dDnjD2YL__"